import { Button } from 'components/lib';
import filter24 from 'images/icons/filter-24.svg';
import filterFilled24 from 'images/icons/filter-filled-24.svg';
import React from 'react';
import { Reference } from 'react-popper';

interface Props {
  onFilterClick: () => void;
  filterApplied: boolean;
}

const FilterButtonCondensed: React.FC<Props> = (props: Props) => {
  const { onFilterClick, filterApplied } = props;

  const filterIcon = filterApplied ? filterFilled24 : filter24;

  return (
    <Reference>
      {({ ref }): React.ReactNode => (
        <div ref={ref} className="hs2 flex items-center">
          <Button
            id="rfi-filter-list"
            variant="tertiary"
            className="row items-center"
            style={{ padding: '0' }}
            onClick={onFilterClick}
          >
            <img
              className="wrem-1p5 primary-blue"
              style={{ width: '32px', height: '32px' }}
              src={filterIcon}
              alt="filter filled icon"
            />
          </Button>
        </div>
      )}
    </Reference>
  );
};

export default FilterButtonCondensed;
